class MiniCartSlider extends HTMLElement {
  constructor() {
    super();
    this.slide = this.querySelector(".swiper");

    window.loadSwiper.then(({ Swiper }) => {
      const swiperParams = {
        slidesPerView: "auto",
        spaceBetween: 5,
        cssMode: true,
      };

      this.swiper = new Swiper(this.slide, swiperParams);
    });
  }
}

if (!customElements.get("mini-cart-slider")) {
  customElements.define("mini-cart-slider", MiniCartSlider);
}
